import { type FunctionComponent, type ReactNode } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';
import { Text } from '@atlaskit/primitives';
import SectionMessage, {
  SectionMessageAction,
} from '@atlaskit/section-message';

const messages = defineMessages({
  launchTitle: {
    id: 'app.updates.launch.banner.title',
    defaultMessage: 'New ways to stay on top of release notes',
    description: 'Title for the launch banner on the app updates list page',
  },
  launchBody: {
    id: 'app.updates.launch.banner.body',
    defaultMessage:
      'Quickly catch up on recent changes with the <strong>New this week</strong> filter and unread indicators, or switch to <strong>Release tracks changes</strong> to review what’s included in upcoming Preview and Bundled releases.',
    description: 'Body text for the launch banner on the app updates list page',
  },
  launchLink: {
    id: 'app.updates.launch.banner.link',
    defaultMessage: 'Learn more on Community',
    description: 'Link text for the launch banner on the app updates list page',
  },
});

const RELEASE_NOTES_LAUNCH_POST_URL =
  'https://community.atlassian.com/forums/Community-Announcements-articles/Two-new-ways-to-stay-on-top-of-Atlassian-Cloud-release-notes/ba-p/3252956';

export const BetaBanner: FunctionComponent = () => {
  const { formatMessage } = useIntl();

  return (
    <SectionMessage
      appearance="discovery"
      title={formatMessage(messages.launchTitle)}
      actions={[
        <SectionMessageAction
          href={RELEASE_NOTES_LAUNCH_POST_URL}
          target="_blank"
        >
          {formatMessage(messages.launchLink)}
        </SectionMessageAction>,
      ]}
    >
      <Text>
        {formatMessage(messages.launchBody, {
          strong: (chunks: ReactNode) => (
            <Text as="span" weight="bold">
              {chunks}
            </Text>
          ),
        })}
      </Text>
    </SectionMessage>
  );
};

export default BetaBanner;
